/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchNotFound from '../../../SearchNotFound';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import services from '../Service';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';

var screenCode = "VIEWGRNINFORMATION"

export default function ViewGrnInformation(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'View GRN Information'
    });

    const [datevalue, setDateValue] = React.useState(new Date().setDate(new Date().getDate()));
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [isHidden, setIsHidden] = useState(false);
    const [plotDetails, setPlotDetails] = useState([]);
    const [tagDetails, setTagDetails] = useState([]);
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(0);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [formData, setFormData] = useState({
        groupID: '',
        operationEntityID: '',
        date: new Date(datevalue).toISOString()
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        date: ''
    });

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const classes = useStyles();

    const viewGrnInformationSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.number().min(1, 'Please Select Operation Entity').required('Operation Entity required'),
        date: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            date: formData.date
        },

        validationSchema: viewGrnInformationSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
            setIsHidden(true)
        }
    });

    //tobackend
    async function SubmitForm() {
        let res = await services.GetViewGrnInformationByGroupIdFactoryIdDate(
            formik.values.groupID,
            formik.values.operationEntityID,
            new Date(datevalue).toISOString().split('T')[0],
        );
        getSelectedDropdownValuesForReport();
        setPlotDetails(res)
        createDataForExcel(res);
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        //formik.resetForm()
        setPlotDetails([]);
        setDateValue(new Date().setDate(new Date().getDate()));
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }
    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setPlotDetails([]);
    }, [datevalue]);

    useEffect(() => {
        setPlotDetails([]);
    }, [formik.values.operationEntityID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGRNINFORMATION');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());

    }

    async function createFile() {
        var file = await createDataForExcel(plotDetails);
        var settings = {
            sheetName: 'GRN Information Report',
            fileName: 'GRN Information Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'GRN Information Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                x.details.map(detail => {
                    var vr = {
                        'GTN Number': x.gtnNumber,
                        'Vehicle Number': x.vehicleNumber,
                        'Driver Name': x.driverName,
                        'Transfer VCC ': x.vccName,
                        'Received VPU': x.vpuName,
                        'Supplier Code': detail.farmerCode,
                        'Supplier Name': detail.firstName,
                        'SKU ': detail.productCode,
                        'Product Name': detail.productName,
                        'Quantity': parseFloat(detail.quantity).toFixed(2)
                    };
                    res.push(vr);
                });
            });

            res.push({});
            res.push({});

            var vr = {
                'GTN Number': "Group: " + selectedSearchValues.groupID,
                'Vehicle Number': "OperationEntity: " + selectedSearchValues.operationEntityID,
                'Driver Name': "Date: " + selectedSearchValues.date
            }
            res.push(vr);
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {

        let groups = groupList.find(x => x.groupID == formik.values.groupID)
        let factorys = operationEntityList.find(x => x.factoryID == formik.values.operationEntityID)
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: factorys.factoryName,
            date: new Date(datevalue).toISOString().split('T')[0]
        });
    }

    const PopUpStyle = makeStyles((theme) => ({
        root: {
            '& > *': {
                width: '25ch'
            }
        }
    }));

    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });

    const handleClose = () => {
        setOpen(false);
    };
    const popUpClass = PopUpStyle();

    function openDialogBox(data) {
        setTagDetails(data)
        setOpen(true)
    }

    function Row(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(false);
        const classes = useRowStyles();

        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" align="center" scope="row">{row.gtnNumber}</TableCell>
                    <TableCell align="center">{row.vehicleNumber}</TableCell>
                    <TableCell align="center">{row.driverName}</TableCell>
                    <TableCell align="center">{row.vccName}</TableCell>
                    <TableCell align="center">{row.vpuName}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {row.details.length != 0 ?
                                <Box margin={1} marginLeft={17}>
                                    <Typography variant="h7" gutterBottom component="div">
                                        <b>GTN Details</b>
                                    </Typography>
                                    <Table size="small" aria-label="purchases">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Supplier Code</TableCell>
                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Supplier Name</TableCell>
                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>SKU</TableCell>
                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Product Name</TableCell>
                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Quantity</TableCell>
                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Tag Details</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {row.details.map((historyRow) => (
                                                <TableRow key={historyRow.performOrderFarmerMappingID}>
                                                    <TableCell align="center" component="th" scope="row">
                                                        {historyRow.farmerCode}
                                                    </TableCell>
                                                    <TableCell align="center">{historyRow.firstName}</TableCell>
                                                    <TableCell align="center">{historyRow.productCode}</TableCell>
                                                    <TableCell align="center">{historyRow.productName}</TableCell>
                                                    <TableCell align="center">{parseFloat(historyRow.quantity).toFixed(2)}</TableCell>
                                                    <TableCell align="center">
                                                        <IconButton aria-label="delete" onClick={() => openDialogBox(historyRow.details)}>
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box> : <Typography variant="h7" gutterBottom component="div">
                                    <b>No GTN Details</b>
                                </Typography>}
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    return (
        <>
            <LoadingComponent />
            <Page title="View GRN Information   |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Operation Entity *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Operation Entity</MenuItem>
                                        {operationEntityList.map((option) => (
                                            <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            fullWidth
                                            size="small"
                                            label="Date *"
                                            openTo="day"
                                            type="date"
                                            inputFormat="MM/DD/YYYY"
                                            value={datevalue}
                                            onChange={(newValue) => {
                                                setDateValue(newValue);
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button type="button" variant="outlined" color="error"
                                        onClick={() => clearAll()}
                                    >
                                        Clear
                                    </Button>
                                    <Button type="submit" color="secondary" variant="outlined"
                                    >
                                        Search
                                    </Button>
                                </Stack>
                                <br />
                                <Divider variant="middle" />
                                <br />
                                <Dialog fullWidth={true} open={open} aria-labelledby="form-dialog-title">
                                    <DialogTitle id="form-dialog-title">{"Tag List"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            <Container>
                                                <Card style={{ justifycontent: 'center', width: '31rem' }}>
                                                    <Paper className={classes.root}>
                                                        <TableContainer component={Paper}>
                                                            <Table aria-label="collapsible table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Tag Number</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {tagDetails.map((row, i) => {
                                                                        return (
                                                                            <TableRow key={i}>
                                                                                <TableCell component="th" scope="row" align="left"> {row.tagNumber}</TableCell>
                                                                            </TableRow>
                                                                        )
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Paper>
                                                </Card>
                                                <DialogActions>
                                                    <Button onClick={handleClose} color="secondary">
                                                        CANCEL
                                                    </Button>
                                                </DialogActions>
                                            </Container>
                                        </DialogContentText>
                                    </DialogContent>
                                </Dialog>
                                <>
                                    {plotDetails.length != 0 ?
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '85rem' }}>
                                                <Paper className={classes.root}>
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="collapsible table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell />
                                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>GTN Number</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Vehicle Number</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Driver Name</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Transfer VCC</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Received VPU</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody >
                                                                {plotDetails.map((row) => (
                                                                    <Row key={row.gtnid} row={row} />
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Paper>
                                            </Card>
                                        </Stack> : <SearchNotFound searchQuery="View GRN Information" />}
                                </>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {plotDetails.length != 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"GRN Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={plotDetails}
                                    searchData={selectedSearchValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}